import React, { useEffect, useRef } from "react";
import ContentEditable, { ContentEditableEvent } from "react-contenteditable";

import { connector, ContainerProps } from "./containers/Keyboard.container";

export type KeyboardProps = {
  content: string;
  highlight: string;
  onEdit: Function;
};

export const KeyboardWrapper: React.FC<KeyboardProps> = ({
  content,
  highlight,
  onEdit,
}) => {
  const contentRef = useRef<ContentEditable>(null);

  const onChange = (evt: ContentEditableEvent) => {
    onEdit(evt.target.value);
  };

  useEffect(() => {
    if (contentRef.current?.el.current.focus)
      contentRef.current?.el.current.focus();
  }, []);

  return (
    <div className="w-full">
      <nav className="container mx-auto px-6 pt-6 relative">
        {content.length === 0 && (
          <div className="absolute editor-visible text-xl italic font-serif text-gray-500 outline-none md:text-2xl">
            Commencez votre haiku... 
          </div>
        )}

        <div className="relative">
          <ContentEditable
            ref={(contentRef as unknown) as string}
            html={content}
            onChange={onChange}
            className="editor-visible relative z-10 text-xl italic font-serif text-gray-700 outline-none md:text-2xl"
          />
          <div
            className="absolute z-0 top-0 left-0 text-xl italic font-serif outline-none editor text-transparent md:text-2xl"
            dangerouslySetInnerHTML={{ __html: highlight }}
          ></div>
        </div>
      </nav>
    </div>
  );
};

export const KeyboardContainer: React.FC<ContainerProps> = (props) => (
  <KeyboardWrapper {...props} />
);

export const Keyboard = connector(KeyboardContainer);
